import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { getReadableDate } from "../../utils";
import ProgressiveControl from "../common/ProgressiveControl";
import ConfirmationWrapper from "../common/ConfirmationWrapper";
import DialogEditBatch from "./DialogEditBatch";
import { useNavigate } from "react-router-dom";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

export default function Batch({ id, title, description, branch_id, branch_title, start_date, end_date, active, updated_at, setBatches }) {
    const { requestAPI, showToast } = useAppContext();
    const navigate = useNavigate();

    const [deleting, setDeleting] = useState();
    const [dialogEditBatch, setDialogEditBatch] = useState({ visible: false });

    const closeDialogEditBatch = useCallback(() => {
        setDialogEditBatch((prev) => ({ ...prev, visible: false }));
    }, []);

    const deleteBatch = useCallback(() => {
        requestAPI({
            requestPath: `batches/${id}`,
            requestMethod: "DELETE",
            setLoading: setDeleting,
            parseResponseBody: false,
            onResponseReceieved: (_, responseCode) => {
                if (responseCode === 204) {
                    showToast({ severity: "success", summary: "Deleted", detail: "Batch Deleted", life: 1000 });
                    setBatches((prev) => prev?.filter((batch) => batch?.id !== id));
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: "Failed To Delete Batch !", life: 2000 });
                }
            },
        });
    }, [id, requestAPI, setBatches, showToast]);

    return (
        <div
            className={`flex gap-3 align-items-center flex-shrink-0 border-1 border-gray-300 border-round p-3 overflow-hidden text-white ${
                active ? "bg-green-500" : "bg-red-500"
            }`}
        >
            <div className="flex flex-column flex-1 min-w-0 gap-1 cursor-pointer" onClick={() => navigate(`/manage-batches/${id}`)}>
                <span className={`${TEXT_NORMAL} font-semibold word-break-all`}>
                    {id}. {title}
                </span>
                {description ? <span className={`${TEXT_SMALL} word-break-all`}>{description}</span> : null}
                <div className="flex align-items-center gap-2 flex-wrap">
                    {branch_title ? (
                        <span className={`${TEXT_SMALL} word-break-all`}>
                            <i className="pi pi-building mr-1" />
                            {branch_title}
                        </span>
                    ) : null}
                    <span className={TEXT_SMALL}>
                        {getReadableDate({ date: start_date, removeTime: true })} – {getReadableDate({ date: end_date, removeTime: true })}
                    </span>
                    <span className={TEXT_SMALL}>Updated {getReadableDate({ date: updated_at })}</span>
                </div>
            </div>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_BATCH}>
                <i
                    className="pi pi-pencil flex-shrink-0 cursor-pointer"
                    onClick={() =>
                        setDialogEditBatch({
                            visible: true,
                            setBatches,
                            id,
                            title,
                            description,
                            branch_id,
                            start_date,
                            end_date,
                            active,
                            closeDialog: closeDialogEditBatch,
                        })
                    }
                />
            </HasRequiredAuthority>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.DELETE_BATCH}>
                <ProgressiveControl
                    loading={deleting}
                    control={
                        <ConfirmationWrapper action={deleteBatch}>
                            <i className="pi pi-trash flex-shrink-0 cursor-pointer" />
                        </ConfirmationWrapper>
                    }
                />
            </HasRequiredAuthority>

            {dialogEditBatch?.visible && <DialogEditBatch {...dialogEditBatch} />}
        </div>
    );
}
